import { HStack, Pressable, View } from "@gluestack-ui/themed";
import { StoreSelectBarVariantEnum, StoreSelectScaffoldProps } from "./types";
import { StoreSelectOptions } from "@repo/core/components/layout/StoreSelectOptions";
import { useStoreSelectScaffoldController } from "@repo/core/components/layout/Scaffolds/StoreSelectScaffold/controller";
import { Modal } from "@repo/core/components/layout/Modal";
import { Icon } from "@repo/core/components/core/Icon";
import { Text } from "@repo/core/components/core/Text";
import { ConfirmStoreModal } from "@repo/core/components/layout/ModalTemplate/ConfirmStoreModal";
import { ScaffoldHeader } from "@repo/core/components/layout/Scaffolds/components/ScaffoldHeader";
import { selectStoreBarStyleByVariant } from "@repo/core/components/layout/Scaffolds/StoreSelectScaffold/utils";
import { StoreSelectorVariantEnum } from "@repo/core/screens/Sales/components/StoreSelector/types";

export const StoreSelectScaffold = ({
  children,
  showSelectStoreBar = true,
  overrideModalRef,
  showConfirmStoreModal = false,
  showHeader = true,
  minHeight = "auto",
  title,
  selectStoreBarVariant = StoreSelectBarVariantEnum.LIGHT,
  storeSelectorVariant = StoreSelectorVariantEnum.BOTH,
  topRightText,
  topRightIcon,
  topRightOnPress,
  ...props
}: StoreSelectScaffoldProps) => {
  const {
    modalRef,
    handleOnSelectStore,
    selectedStore,
    enableSelectStore,
    confirmStoreModalRef,
    handleOnSelectCancelConfirmStoreModal,
    onSelectStoreSuccess,
    isMobile
  } = useStoreSelectScaffoldController({
    overrideModalRef,
    showConfirmStoreModal
  });

  const selectStoreBarStyles =
    selectStoreBarStyleByVariant[selectStoreBarVariant];

  return (
    <>
      <View flex={1} minHeight={minHeight} w="$full">
        <HStack
          w="$full"
          alignItems="center"
          px="$4"
          bg={selectStoreBarStyles.bg}
        >
          <View flex={0.5} />
          {showSelectStoreBar && enableSelectStore && (
            <Pressable
              onPress={handleOnSelectStore}
              disabled={!enableSelectStore}
              flex={1}
            >
              <HStack
                p="$2"
                alignItems="center"
                space="sm"
                justifyContent="center"
              >
                <Icon
                  name="location-dot"
                  color={selectStoreBarStyles.iconColor}
                  size={16}
                />
                {selectedStore && (
                  <Text
                    color={selectStoreBarStyles.textColor}
                    fontSize="$xs"
                    fontWeight={600}
                  >
                    {storeSelectorVariant ===
                    StoreSelectorVariantEnum.SHOPKEEPER
                      ? selectedStore.descrLojista
                      : selectedStore?.descrLoja}
                  </Text>
                )}
                <Icon
                  name="chevron-down"
                  color={selectStoreBarStyles.chevronColor}
                  size={16}
                />
              </HStack>
            </Pressable>
          )}
          {!isMobile && topRightText ? (
            <HStack
              gap="$2"
              alignItems="center"
              justifyContent="flex-end"
              flex={0.5}
            >
              <Text fontSize="$2xs" color="$secondary600">
                {topRightText}
              </Text>

              {topRightIcon && (
                <Pressable onPress={topRightOnPress}>
                  <Icon name={topRightIcon} size={16} color="$secondary600" />
                </Pressable>
              )}
            </HStack>
          ) : (
            <View flex={0.5} />
          )}
        </HStack>
        {showHeader && <ScaffoldHeader title={title} {...props} />}
        {children}
      </View>
      {modalRef && (
        <Modal ref={modalRef}>
          <View p="$2" bg="$backgroundLight0">
            <StoreSelectOptions
              onClose={() => modalRef.current?.close()}
              onSelectStoreSuccess={onSelectStoreSuccess}
              storeSelectorVariant={storeSelectorVariant}
            />
          </View>
        </Modal>
      )}
      {showConfirmStoreModal && confirmStoreModalRef && (
        <ConfirmStoreModal
          ref={confirmStoreModalRef}
          onSelectCancel={handleOnSelectCancelConfirmStoreModal}
        />
      )}
    </>
  );
};
